import React from 'react';
import PropTypes from 'prop-types';

import Task from './Task';

const TodoList = ({
  tasks,
  toggleConfirmationAt,
  toggleEditingAt,
  removeTaskAt,
  setTitleAt
}) => {
  return (
    <ul className='todolist'>
      {tasks.map((task, index) => (
        <Task
          key={index}
          title={task.title}
          isEditing={task.isEditing}
          isCompleted={task.isCompleted}
          handleConfirmation={() => toggleConfirmationAt(index)}
          handleToggleEditing={() => toggleEditingAt(index)}
          removeGuest={() => removeTaskAt(index)}
          setTitle={text => setTitleAt(text, index)}
        />
      ))}
    </ul>
  );
};

TodoList.propTypes = {
  tasks: PropTypes.array.isRequired,
  toggleConfirmationAt: PropTypes.func.isRequired,
  toggleEditingAt: PropTypes.func.isRequired,
  removeTaskAt: PropTypes.func.isRequired,
  setTitleAt: PropTypes.func.isRequired
};

export default TodoList;
